/**
 * Identidade visual em texto — o UNICO arquivo a editar para trocar a marca.
 *
 * Trocar a marca inteira e mudar as quatro strings abaixo: o nome no topo do
 * sidebar, as iniciais do avatar quadrado, e o par titulo/subtitulo que o header
 * mostra por padrao. Nenhum componente escreve o nome da marca inline — se voce
 * encontrar um literal "Valbot" fora daqui, e um bug de manutencao esperando
 * para acontecer.
 *
 * O titulo da aba (metadata) tambem sai daqui, em src/app/layout.tsx.
 */
export const BRAND = {
  /** Nome exibido ao lado do avatar no topo do sidebar. */
  name: "Valbot",
  /** Iniciais do avatar quadrado-arredondado do sidebar (2 letras cabem bem). */
  initials: "VB",
  /** Titulo padrao do header, usado quando a rota nao tem titulo proprio. */
  appTitle: "App Valbot",
  /** Subtitulo padrao do header (linha cinza, menor). */
  tagline: "Painel",
} as const;
